export const TAB_CA = 'chronological/CA';

export const TAB_SOLD = 'chronological/SOLD';

export const TAB_UNSOLD = 'chronological/UNSOLD';

export const TAB_AVERAGE = 'chronological/AVERAGE';
